export { default as stateToMarkdown } from './stateToMarkdown';


//////////////////
// WEBPACK FOOTER
// ../draft-js-export-markdown/esm/main.js
// module id = 2189
// module chunks = 25